<template>
	<div class="layout-footer">
		<img alt="Logo" :src="footerImage()" height="50" class="mr-2" />
		by
		<span class="font-medium ml-2">Mahajyoti</span>
	</div>
</template>

<script>
	export default {
		name: "AppFooter",
		methods: {
			footerImage() {
				return this.$appState.darkTheme ? 'images/download.png' : 'images/download.png';
			}
		},
		computed: {
			darkTheme() {
				return this.$appState.darkTheme;
			}
		}
	}
</script>